'use client';

import { Users, TrendingUp, Heart, Award } from 'lucide-react';

interface QuizInterstitialProps {
  title: string;
  content: string;
  image?: string;
  type?: 'social-proof' | 'education' | 'expert' | 'generic';
}

export function QuizInterstitial({
  title,
  content,
  image,
  type = 'generic',
}: QuizInterstitialProps) {
  const getIcon = () => {
    switch (type) {
      case 'social-proof':
        return <Users size={48} className="text-blue-500" />;
      case 'education':
        return <TrendingUp size={48} className="text-green-500" />;
      case 'expert':
        return <Award size={48} className="text-yellow-500" />;
      default:
        return <Heart size={48} className="text-pink-500" />;
    }
  };

  return (
    <div className="w-full max-w-2xl mx-auto px-4 py-12">
      <div className="text-center space-y-6">
        {image ? (
          <div className="mb-8">
            <img
              src={image}
              alt={title}
              className="w-full max-w-md mx-auto rounded-2xl"
            />
          </div>
        ) : (
          <div className="flex justify-center mb-6">{getIcon()}</div>
        )}

        <h2 className="text-3xl md:text-4xl font-bold text-white">
          {title}
        </h2>

        <div className="text-gray-300 text-lg leading-relaxed max-w-xl mx-auto whitespace-pre-line">
          {content}
        </div>

        {type === 'social-proof' && (
          <div className="flex justify-center items-center gap-3 pt-4">
            <div className="px-4 py-2 rounded-lg bg-blue-500/10 border border-blue-500/30">
              <span className="text-lg font-bold text-blue-400">
                Top 20%
              </span>
            </div>
            <span className="text-gray-400">vs</span>
            <div className="px-4 py-2 rounded-lg bg-gray-800 border border-gray-700">
              <span className="text-lg font-bold text-gray-500">
                Bottom 80%
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
